import { EstadosEquipos } from '../enums/estados-equipos.enum';
import { EstadosGestion } from '../enums/estados-gestion.enum';

export const ESTADOS_EQUIPOS = <Record<EstadosGestion, EstadosEquipos[]>>{
  [EstadosGestion.Asignados]: [EstadosEquipos.Asignado],
  [EstadosGestion.NoAsignados]: [
    EstadosEquipos.Stock,
    EstadosEquipos.NoAsignado,
    EstadosEquipos.Principal,
    EstadosEquipos.Backup,
    EstadosEquipos.Vacio,
  ],
  [EstadosGestion.Baja]: [
    EstadosEquipos.Baja,
    EstadosEquipos.Vendido,
    EstadosEquipos.Robo,
  ],
};
